(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daluz-brand-picker"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('daluz-brand-picker'))customElements.define('daluz-brand-picker',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.brand=this.querySelector('[data-manufacturer]');this.model=this.querySelector('[data-model]');this.valueInput=this.querySelector('[data-brand-value]');this.catalog=JSON.parse(this.querySelector('[data-brand-catalog]').textContent);this.brand.addEventListener('change',()=>{this.populate();this.sync()});this.model.addEventListener('change',()=>this.sync());this.closest('form').addEventListener('reset',()=>setTimeout(()=>{this.populate();this.sync()},0));this.populate();this.sync()}
populate(){this.model.replaceChildren(new Option(this.dataset.placeholder,''));const models=this.catalog[this.brand.value]||[];for(const name of models)this.model.add(new Option(name,name));this.model.disabled=models.length===0}
sync(){this.valueInput.value=this.model.value?this.brand.value+' — '+this.model.value:'';if(this.dataset.productMode==='true'){const known=this.catalog[this.brand.value];this.brand.setCustomValidity(this.brand.value&&this.brand.value!=='unknown'&&!known?this.dataset.mismatch:'');const ok=known&&known.includes(this.model.value);this.model.setCustomValidity(this.model.value&&!ok?this.dataset.mismatch:'')}this.valueInput.dispatchEvent(new Event('input',{bubbles:true}))}
});
  } catch(e) { console.error(e); }
})();

})();
